import React from "react";
import "../../assets/css/templateBuilder.css";
import "../../assets/css/addunit.css";
import "../../assets/css/mainMenu.css";
import ArrowLineRight from "../../assets/icons/ArrowLineRight.svg";
const Sidebar = ({ master, usedNodes, searchQuery }) => {
  const onDragStart = (event, masterId) => {
    event.dataTransfer.setData("application/reactflow", masterId);
    event.dataTransfer.effectAllowed = "move";

  };
  const groupNodes = (masters) => {
    const groupedItems = [];
    for (let i = 0; i < masters.length; i += 2) {
      groupedItems.push(masters.slice(i, i + 2));
    }
    return groupedItems;
  };

  const filterAndSortMasters = (parameterType) => {
    const filteredMasters = parameterType.masters.filter((master) =>
      master.master_name.toLowerCase().includes(searchQuery.toLowerCase())
    );

    // Sort the filtered masters such that the items matching the search query are at the top
    filteredMasters.sort((a, b) => {
      const aMatches = a.master_name.toLowerCase().startsWith(searchQuery.toLowerCase());
      const bMatches = b.master_name.toLowerCase().startsWith(searchQuery.toLowerCase());
      return bMatches - aMatches;
    });

    return filteredMasters;
  };
  return (
    <div className="row" style={{ marginRight: 0, marginLeft: 0 }}>
      <div className="col-md-3 p-0 left" style={{ width: "300px" }}>
        <div className="accordion" id="accordionExample">
          {master && master.parameter_types ? (
            master.parameter_types.map((parameterType, idx) => (
              <div className="accordion-item tb-accordion-item" key={idx}>
                <h2 className="accordion-header" id={`heading${idx}`}>
                  <button
                    className="accordion-button d-flex align-content-center justify-content-between"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse${idx}`}
                    aria-expanded="true"
                    aria-controls={`collapse${idx}`}
                  >
                    <div className="d-flex gap-3">
                      <p className="m-0 medium-body">
                        {parameterType.parameterTypeName}
                      </p>
                    </div>
                    <img
                      className="icon-rotate"
                      src={ArrowLineRight}
                      alt="Toggle"
                    />
                  </button>
                </h2>
                <div
                  id={`collapse${idx}`}
                  className="accordion-collapse collapse show"
                  aria-labelledby={`heading${idx}`}
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body tb-accordion-body">
                    {groupNodes(filterAndSortMasters(parameterType)).map(
                      (group, groupIdx) => (
                        <div
                          key={groupIdx}
                          className="d-flex justify-content-between gap-2 tb-accordion-body align-content-center mb-2"
                        >
                          {group.map((item) => {
                            const isDisabled = usedNodes.includes(item._id);
                            return (
                              <span
                                key={item._id}
                                className={`align-content-center text-truncate text-center dndnode ${isDisabled ? "disabled" : ""
                                  }`}
                                onDragStart={(event) =>
                                  !isDisabled && onDragStart(event, item._id)
                                }
                                draggable={!isDisabled}
                              >
                                {item.master_name}
                              </span>
                            );
                          })}
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p>Loading...</p>
          )}
        </div>
      </div>
    </div>
  );
};
export default Sidebar;